namespace $.$$ {

	export class $shm_projects_docs extends $.$shm_projects_docs {

		override Toc_page() {
			const page = super.Toc_page()
			page.title_content = ()=> [ this.Modes() ]
			return page
		}

		mode() {
			const mode = this.$.$mol_state_arg.value( 'docs_file' )
			return mode === 'agents' || mode === 'config' ? mode : 'readme'
		}

		readme_current() {
			return this.mode() === 'readme'
		}

		agents_current() {
			return this.mode() === 'agents'
		}

		config_current() {
			return this.mode() === 'config'
		}

		mode_text() {
			switch( this.mode() ) {
				case 'agents': return this.agents_text()
				case 'config': return this.config_text()
				default: return this.readme_text()
			}
		}

	}

}
